import BootstrapField from '../utility/BootstrapField';
export default class CreateAccount {

	static get getYesNoOptions() {
		return [
			{text: 'Yes', value: 1},
			{text: 'No', value: 0}
		];
	}
	static get getOrganizationTypeId() {
		return [
		{value:'city', text:'City of Winnipeg'},
		{value:'province', text:'Province of Manitoba'},
		{value:'utility', text:'Utility'},
		{value:'agency', text:'Construction Agency'},
		{value:'other', text:'Other'},
		];
	}
	static get getIsApprovedOptions() {
		return [
		{value:1, text:"Approved"},
		{value:0, text:"Not Approved"},
		];
	}
	static get getIsActiveOptions() {
		return [
		{value:1, text:"Active"},
		{value:0, text:"Inactive"},
		];
	}
	constructor(data) {
		if (!data) {
			data = {};
		}
		Object.assign(this, {
			id: data.id || null,
			organizationId:new BootstrapField({
				value: data.organizationId || null,
				required: true,
			}),
			name:new BootstrapField({
				value: data.name || null,
				required: false,
			}),
			domain: new BootstrapField({
				value: data.domain || null,
				required:true,
			}),
			username: new BootstrapField({
				value: data.username || null,
			}),
			firstName: new BootstrapField({
				value: data.firstName || null,
				required:true,
			}),
			password: new BootstrapField({
				value: data.password || null,
				required:true,
			}),
			lastName: new BootstrapField({
				value: data.lastName || null,
				required:true,
			}),
			title: new BootstrapField({
				value: data.title || null,
			}),
			email: new BootstrapField({
				value: data.email || null,
				required:true,
			}),
			phone: new BootstrapField({
				value: data.phone || null,
				required:true,
			}),
			altPhone: new BootstrapField({
				value: data.altPhone || null,
			}),
			jwt: data.jwt || null,
		});

		// Keep a record of the old data. (used for the hasChanges() method)
		// originalOrganizationData = CloneDeep(this);
	}

	validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		console.log(errors)
		return flag;
	}

	getRawValue() {
		return getRawValue(this);
		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getRawValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);
		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {

		// var differences = DeepDiff.diff(originalOrganizationData.getRawValue(),  this.getRawValue());

		// return !IsEqual(originalOrganizationData.getRawValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalOrganizationData);
	}
	saveChanges() {
		// originalOrganizationData = CloneDeep(this);
	}
}